export default __webpack_public_path__ + "static/media/036-printer.acb96bbf.svg";